import React, { useState } from "react";
import { IoChevronBack, IoClose } from "react-icons/io5";
import { HandleForgotPassword } from "../../services/Firebase";

export default function ForgotPasswordModal({ onClose, onBack }) {
    const [email, setEmail] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);

    const handleSubmit = async () => {
        await HandleForgotPassword(email);
        onClose();
    };

    const ValidateEmailAddress = (value) => {
        setEmail(value);

        if (!isValidEmail) {
            setErrorMsg("Enter a valid email address.");
        } else {
            setErrorMsg("");
        }
    };

    return (
        <>
            {/* Blurred Background */}
            <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-40"></div>

            {/* Modal */}
            <div className="fixed inset-0 flex items-center justify-center z-50">
                <div className="bg-black/40 backdrop-blur-xl border border-white/10 rounded-2xl p-6 w-[90%] md:w-[450px] shadow-xl"
                    onMouseDown={(e) => e.stopPropagation()}>

                    {/* Header */}
                    <div className="flex justify-between items-center mb-4">
                        <button onClick={onBack}>
                            <IoChevronBack className="text-white text-2xl" />
                        </button>

                        <button onClick={onClose}>
                            <IoClose className="text-white text-2xl" />
                        </button>
                    </div>

                    {/* Title */}
                    <h2 className="text-white text-xl font-semibold text-center">
                        Forgot Password
                    </h2>
                    <p className="text-gray-300 text-center text-sm mt-1">
                        Enter your e-mail!
                    </p>

                    {/* Email Input */}
                    <div className="mt-6">
                        <label className="text-gray-300 text-sm">Email</label>

                        <input
                            type="email"
                            placeholder="Enter your e-mail"
                            value={email}
                            onChange={(e) => ValidateEmailAddress(e.target.value)}
                            className="w-full mt-2 bg-black/40 text-white border border-white/20 rounded-full px-5 py-3 outline-none focus:border-red-500 transition"
                        />

                        {/* Error Message */}
                        {errorMsg && (
                            <p className="text-red-500 text-sm mt-2">{errorMsg}</p>
                        )}
                    </div>

                    {/* Continue Button */}
                    <button
                        onClick={handleSubmit}
                        disabled={!isValidEmail}
                        className={`w-full mt-6 py-3 rounded-full text-lg font-semibold transition
              ${isValidEmail
                                ? "bg-red-500 text-white"
                                : "bg-red-500/40 text-gray-300 cursor-not-allowed"
                            }`}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </>
    );
}